import { get, values } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getEstimateWatchers = createSelector(get('estimateWatchers'), (watchers = {}) => {
  return values(watchers);
});
